import { FC } from 'react';
import { Link } from 'react-router-dom';

import { Crown, Drama, ShieldBan } from 'lucide-react';

import Chip from '@mui/material/Chip';

import css from './UserSettingsUserColumn.module.css';

import { UserAvatar } from 'v2/components/userAvatar/UserAvatar';
import { UserModel } from 'v2/types/UserModel';

interface UserSettingsUserColumnProps {
  user: UserModel;
}

export const UserSettingsUserColumn: FC<UserSettingsUserColumnProps> = ({ user }) => (
  <div className={css.userSettingsUserColumn}>
    <UserAvatar imageUrl={user.imgUrl} />

    <div>
      <Link to={`/user-profile/${user.id}`} className={css.userSettingsUserNameLink}>
        {user.userNickname}
      </Link>

      <div className={css.userSettingsMarks}>
        {user.isNewUser && <Chip label="NEW" color="info" size="small" />}

        {user.levelVipPoints > 0 && (
          <Chip label="VIP" color="secondary" size="small" icon={<Crown width={14} height={14} />} />
        )}

        {user.isCheater && (
          <Chip label="Cheater" color="warning" size="small" icon={<Drama width={16} height={16} />} />
        )}

        {user.isBanned && (
          <Chip label="Banned" color="error" size="small" icon={<ShieldBan width={14} height={14} />} />
        )}
      </div>
    </div>
  </div>
);
